/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateContactListRequestContactList
 */
export interface CreateContactListRequestContactList {
  /**
   *
   * @type {string}
   * @memberof CreateContactListRequestContactList
   */
  name?: string
}

export function CreateContactListRequestContactListFromJSON(json: any): CreateContactListRequestContactList {
  return CreateContactListRequestContactListFromJSONTyped(json, false)
}

export function CreateContactListRequestContactListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateContactListRequestContactList {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name']
  }
}

export function CreateContactListRequestContactListToJSON(value?: CreateContactListRequestContactList | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name
  }
}
